'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypes = require('./tradeTypes');

var _tradeTypes2 = _interopRequireDefault(_tradeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (text) {
    var tradeType = _tradeTypes2.default.find(function (x) {
        return x.text === text;
    });
    if (!tradeType) throw new Error('Unknown trade type text');
    return tradeType.value;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/trade/tradeTypeTextToCode.js
// module id = 130
// module chunks = 0